import React, { useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  Typography,
  Badge,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CollectionsIcon from "@mui/icons-material/Collections";

const ImageCard = ({
  src,
  onDelete,
  type,
  badgeContent = 1,
  index,
  handleCountChange,
  plusMarge = false,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Card
        style={{
          position: "relative",
          borderRadius: "20px",
          width: "80%",
          textAlign: "center",
        }}
      >
        <IconButton
          onClick={() => handleCountChange(index, -1)}
          style={{
            position: "absolute",
            top: "6%",
            left: plusMarge ? "40%" : "65%", // Position the button left side
            transfor5: "translateY(-50%)",
            color: "#1976d2",
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "2px", // Make the button circular and similar to badge
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Optional shadow for a floating effect
          }}
        >
          <RemoveIcon />
        </IconButton>

        <Badge
          badgeContent={badgeContent}
          color="error"
          style={{
            position: "absolute",
            top: "10%",
            left: plusMarge ? "67%" : "80%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "2px",
            zIndex: 2,
          }}
        >
          <CollectionsIcon />
        </Badge>

        <IconButton
          onClick={() => handleCountChange(index, +1)}
          style={{
            position: "absolute",
            top: "10%",
            right: "10px", // Position the button right side
            transform: "translateY(-50%)",
            color: "#1976d2",
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "2px", // Make the button circular and similar to badge
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Optional shadow for a floating effect
          }}
        >
          <AddIcon />
        </IconButton>
        <CardMedia
          component="img"
          style={{ width: "100%" }}
          image={src}
          alt="Image"
          sx={{
            width:
              type === "polaroid" ? "100%" : type === "instax" ? "90%" : "80%",
            height: "auto",
            maxWidth:
              type === "polaroid"
                ? "300px"
                : type === "instax"
                ? "400px"
                : "none",
            maxHeight: type === "polaroid" ? "300px" : "none",
            aspectRatio:
              type === "polaroid"
                ? "1 / 1"
                : type === "instax"
                ? "3 / 4"
                : "unset",
          }}
        />

        <IconButton
          onClick={onDelete}
          style={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            backgroundColor: "white", // White background for the circle
            color: "#B31312", // Red color for the icon
            borderRadius: "50%", // Make the button circular
            //border: "2px solid #B31312", // Red border around the circle
            padding: "2px", // Adjust padding for proper spacing
          }}
        >
          <CancelIcon />
        </IconButton>
      </Card>
    </Box>
  );
};

export default ImageCard;
